// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-attribute-item {
  padding: 10px 13px;
  font-size: 12px;
  display: inline-flex;
  min-width: 220px;
  text-align: center;
  position: relative;
  justify-content: space-between;
  align-items: center;
}
.all-attribute-item .attr-label {
  display: block;
  font-size: 16px;
}
.all-attribute-item .attr-value {
  font-size: 18px;
  font-weight: 700;
  display: block;
  word-break: break-word;
}
@media (max-width: 959px) {
  .all-attribute-item {
    min-width: 150px;
  }
}

.tab_menu_icon {
  vertical-align: middle;
  float: left;
  width: 24px;
  height: 24px;
}

.tab-selected .menu_item_text_inner {
  display: inline-block;
  margin-left: 10px;
}

.menu_item_text {
  line-height: 24px;
}

.menu_item_text_inner {
  display: none;
}

.page-title-notification,
.page-title-2,
.page-title,
.v-tab-heading {
  margin: 0;
  line-height: 24px;
  display: inline-block;
  font-size: 18px;
  font-family: "Bebas Neue", sans-serif;
  font-weight: 500;
  margin-right: 10px;
}
.page-title-notification span,
.page-title-2 span,
.page-title span,
.v-tab-heading span {
  vertical-align: top;
  color: #b0b0b0;
}

.page-title {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Users/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AACA;EACC,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAAD;AAaC;EACC,cAAA;EACA,eAAA;AAXF;AAcC;EACC,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAZF;AAeC;EAjCD;IAkCE,gBAAA;EAZA;AACF;;AAgBA;EACC,sBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAbD;;AAiBC;EACC,qBAAA;EACA,iBAAA;AAdF;;AAkBA;EACC,iBAAA;AAfD;;AAkBA;EACC,aAAA;AAfD;;AAkBA;;;;EAIC,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,qCCwBe;EDvBf,gBAAA;EACA,kBAAA;AAfD;AAiBC;;;;EACC,mBAAA;EACA,cAAA;AAZF;;AAgBA;EACC,mBAAA;AAbD","sourcesContent":["@import './../../assets/variables';\n.all-attribute-item {\n\tpadding: 10px 13px;\n\tfont-size: 12px;\n\tdisplay: inline-flex;\n\tmin-width: 220px;\n\ttext-align: center;\n\tposition: relative;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t// &:before {\n\t// \tcontent: \"\";\n\t// \tposition: absolute;\n\t// \tdisplay: block;\n\t// \twidth: 50px;\n\t// \theight: 2px;\n\t// \tleft: 50%;\n\t// \tmargin-left: -25px;\n\t// \ttop: 100%;\n\t// }\n\n\t.attr-label {\n\t\tdisplay: block;\n\t\tfont-size: 16px;\n\t}\n\n\t.attr-value {\n\t\tfont-size: 18px;\n\t\tfont-weight: 700;\n\t\tdisplay: block;\n\t\tword-break: break-word;\n\t}\n\n\t@media (max-width: 959px) {\n\t\tmin-width: 150px;\n\t}\n}\n\n\n.tab_menu_icon {\n\tvertical-align: middle;\n\tfloat: left;\n\twidth: 24px;\n\theight: 24px;\n}\n\n.tab-selected {\n\t.menu_item_text_inner {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 10px;\n\t}\n}\n\n.menu_item_text {\n\tline-height: 24px;\n}\n\n.menu_item_text_inner {\n\tdisplay: none;\n}\n\n.page-title-notification,\n.page-title-2,\n.page-title,\n.v-tab-heading {\n\tmargin: 0;\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\tfont-family: $altFontFamily;\n\tfont-weight: 500;\n\tmargin-right: 10px;\n\n\tspan {\n\t\tvertical-align: top;\n\t\tcolor: #b0b0b0;\n\t}\n}\n\n.page-title {\n\tmargin-bottom: 10px;\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
